let deleteDialogTrigger;

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || "";
}

function profilePage() {
  return document.querySelector("[data-profile-page]");
}

function preferenceFeedback(form, message) {
  const feedback = form.querySelector("[data-profile-preference-feedback]");
  if (feedback) feedback.textContent = message;
}

async function savePreference(input) {
  const form = input.closest("[data-profile-preference-form]");
  const page = profilePage();
  if (!form || !page || input.disabled) return;

  const oldChecked = !input.checked;
  const localeValue = form.querySelector("[data-profile-locale-value]");
  const oldLocale = localeValue?.value;
  if (input.matches("[data-profile-locale-toggle]") && localeValue) {
    localeValue.value = input.checked ? "en" : "de";
  }

  input.disabled = true;
  input.setAttribute("aria-busy", "true");
  preferenceFeedback(form, "");

  try {
    const formData = new FormData(form);
    if (input.name) formData.set(input.name, input.checked ? input.value : "0");

    const response = await fetch(form.action, {
      method: "PATCH",
      body: formData,
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": csrfToken(),
      },
    });
    const data = await response.json();
    if (!response.ok || data.updated !== true) throw new Error("Preference update failed");

    if (data.locale_changed && data.redirect_url) {
      window.location.assign(data.redirect_url);
      return;
    }

    preferenceFeedback(form, page.dataset.profileSaved);
  } catch (_error) {
    input.checked = oldChecked;
    if (localeValue) localeValue.value = oldLocale;
    preferenceFeedback(form, page.dataset.profileError);
  } finally {
    input.disabled = false;
    input.removeAttribute("aria-busy");
  }
}

function deleteDialog() {
  return document.querySelector("[data-profile-delete-dialog]");
}

function updateDeleteSubmit(form) {
  if (!form) return;

  const phrase = form.querySelector("[data-profile-delete-phrase]");
  const password = form.querySelector("[data-profile-delete-password]");
  const submit = form.querySelector("[data-profile-delete-submit]");
  if (!phrase || !password || !submit) return;

  submit.disabled = phrase.value !== form.dataset.deletePhrase || password.value.length === 0;
}

function openDeleteDialog(trigger) {
  const dialog = deleteDialog();
  if (!dialog) return;

  deleteDialogTrigger = trigger;
  if (!dialog.open && typeof dialog.showModal === "function") {
    dialog.showModal();
  } else if (!dialog.open) {
    dialog.setAttribute("open", "");
  }
  const invalidField = dialog.querySelector("[data-profile-delete-invalid='true']");
  (invalidField || dialog.querySelector("[data-profile-delete-phrase]"))?.focus();
}

function closeDeleteDialog({ restoreFocus = true } = {}) {
  const dialog = deleteDialog();
  if (!dialog?.open) return;

  if (typeof dialog.close === "function") {
    dialog.close();
  } else {
    dialog.removeAttribute("open");
  }
  if (restoreFocus) deleteDialogTrigger?.focus();
}

function initializeProfile() {
  const dialog = deleteDialog();
  const form = dialog?.querySelector("[data-profile-delete-form]");
  updateDeleteSubmit(form);

  if (dialog?.dataset.open === "true" && !dialog.open) {
    openDeleteDialog(document.querySelector("[data-profile-delete-open]"));
  }
}

document.addEventListener("click", function (event) {
  const deleteOpen = event.target.closest?.("[data-profile-delete-open]");
  if (deleteOpen) {
    openDeleteDialog(deleteOpen);
    return;
  }

  if (event.target.closest?.("[data-profile-delete-close]")) {
    closeDeleteDialog();
    return;
  }

  const dialog = event.target.closest?.("[data-profile-delete-dialog]");
  if (dialog && event.target === dialog) closeDeleteDialog();
});

document.addEventListener("change", function (event) {
  if (event.target.matches?.("[data-profile-preference-input]")) savePreference(event.target);
});

document.addEventListener("input", function (event) {
  const form = event.target.closest?.("[data-profile-delete-form]");
  if (form) updateDeleteSubmit(form);
});

document.addEventListener("close", function (event) {
  if (event.target.matches?.("[data-profile-delete-dialog]")) deleteDialogTrigger?.focus();
}, true);

document.addEventListener("turbo:before-render", function () {
  closeDeleteDialog({ restoreFocus: false });
});

document.addEventListener("turbo:load", initializeProfile);
document.addEventListener("turbo:render", initializeProfile);
document.addEventListener("pageshow", initializeProfile);

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeProfile);
} else {
  initializeProfile();
}
